import React, { useState } from "react";
import { Scatter } from "react-chartjs-2";
import { Nav } from "react-bootstrap";
import {
  Chart as ChartJS,
  LinearScale,
  PointElement,
  Tooltip
} from "chart.js";

ChartJS.register(LinearScale, PointElement, Tooltip);

/* employee avatars from assets folder */

const avatars = [
"/assets/img/users/user-01.jpg",
"/assets/img/users/user-02.jpg",
"/assets/img/users/user-03.jpg",
"/assets/img/users/user-04.jpg",
"/assets/img/users/user-05.jpg",
"/assets/img/users/user-06.jpg",
"/assets/img/users/user-07.jpg",
"/assets/img/users/user-08.jpg",
"/assets/img/users/user-09.jpg",
"/assets/img/users/user-10.jpg"
];

/* chart datasets */

const chartSets = {

"1D":[102,96,104,103,105,70,45,80,78,85],

"7D":[80,85,90,88,92,70,65,75,78,82],

"1M":[60,70,75,80,85,90,92,88,95,98],

"1Y":[30,40,50,60,70,80,90,100,105,110]

};

export default function TopEmployees(){

const [tab,setTab] = useState("1D");

const values = chartSets[tab];

const data = {
datasets:[
{
data: values.map((v,i)=>({x:i+1,y:v})),
pointBackgroundColor:"#1f5a67",
pointRadius:6
}
]
};

/* vertical lines */

const linePlugin={
id:"linePlugin",
afterDraw(chart){

const {ctx,scales}=chart;

values.forEach((v,i)=>{

const x=scales.x.getPixelForValue(i+1);
const y=scales.y.getPixelForValue(v);

/* stop line above avatar */

const bottom=scales.y.getPixelForValue(15);

ctx.beginPath();
ctx.moveTo(x,bottom);
ctx.lineTo(x,y);
ctx.lineWidth=6;
ctx.strokeStyle="#b8c6cb";
ctx.stroke();

});

}
};

/* avatar images */

const avatarPlugin={
id:"avatarPlugin",
afterDraw(chart){

const {ctx,scales}=chart;

const y=scales.y.bottom + 22;

avatars.forEach((img,i)=>{

const x=scales.x.getPixelForValue(i+1);

const image=new Image();
image.src=img;

ctx.save();

ctx.beginPath();
ctx.arc(x,y,14,0,Math.PI*2);
ctx.clip();

ctx.drawImage(image,x-14,y-14,28,28);

ctx.restore();

});

}
};

const options={

responsive:true,
maintainAspectRatio:false,

layout:{
padding:{
bottom:40
}
},

plugins:{
legend:{display:false},
tooltip:{
backgroundColor:"#fff",
titleColor:"#333",
bodyColor:"#333",
borderColor:"#e5e7eb",
borderWidth:1
}
},

scales:{

x:{
min:1,
max:10,
grid:{display:false},
ticks:{display:false},
border:{display:false}
},

y:{
min:0,
max:115,   /* slightly above 110 */
ticks:{
stepSize:50,
color:"#9ca3af"
},
grid:{
color:"#e5e7eb"
}
}

}

};

return(

<div className="card p-3 mt-1">

{/* Header */}

<div className="d-flex justify-content-between align-items-center mb-3">

<h5 className="fw-semibold">Top Employees</h5>

<Nav className="bg-light p-1 rounded">

{["1D","7D","1M","1Y"].map(t=>(
<Nav.Link
key={t}
onClick={()=>setTab(t)}
className={`px-2 py-1 ${tab===t ? "bg-warning text-white rounded" : ""}`}
>
{t}
</Nav.Link>
))}

</Nav>

</div>

{/* Chart */}

<div style={{height:"180px"}}>
<Scatter
data={data}
options={options}
plugins={[linePlugin,avatarPlugin]}
/>
</div>

</div>

);
}